import React, { FunctionComponent } from "react";

const Circle: FunctionComponent = () => (
  <svg
    width={"24"}
    height={"24"}
    viewBox={"0 0 24 24"}
    fill={"none"}
    xmlns={"http://www.w3.org/2000/svg"}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M0 12C0 5.376 5.376 0 12 0C18.624 0 24 5.376 24 12C24 18.624 18.624 24 12 24C5.376 24 0 18.624 0 12ZM2.4 12C2.4 6.7008 6.7008 2.4 12 2.4C17.2992 2.4 21.6 6.7008 21.6 12C21.6 17.2992 17.2992 21.6 12 21.6C6.7008 21.6 2.4 17.2992 2.4 12Z"
      fill="black"
    />
  </svg>
);

export default Circle;
